export default function ResultsSection() {
  return (
    <section id="results" className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-12 md:mb-16">
          <h3 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
            導入効果
          </h3>
          <p className="text-sm text-foreground-500 tracking-[0.08em] font-sans font-light">
            実績に基づく数値
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {/* Result 1 */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20close-up%20photography%20of%20a%20modern%20server%20node%20with%20glowing%20LED%20indicators%20in%20a%20data%20center%2C%20shallow%20depth%20of%20field%2C%20blue%20and%20green%20lights%2C%20dark%20ambient%20background%2C%20technology%20infrastructure%2C%20no%20people&width=480&height=600&seq=result-detection&orientation=portrait"
                alt="不正検知率"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/80 backdrop-blur-sm text-accent-400 text-sm md:text-base font-heading tracking-[0.05em]">99.9%</span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h4 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">不正検知率</h4>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light">AIエンジンによる高精度検知</p>
            </div>
          </div>

          {/* Result 2 */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20financial%20analyst%20workstation%20with%20multiple%20monitors%20displaying%20data%20charts%20and%20graphs%2C%20dark%20ambient%20office%20lighting%2C%20clean%20desk%2C%20modern%20setup%2C%20no%20person%20visible%2C%20focus%20on%20screens%20and%20equipment&width=480&height=600&seq=result-analyst&orientation=portrait"
                alt="誤検知率"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/80 backdrop-blur-sm text-accent-400 text-sm md:text-base font-heading tracking-[0.05em]">0.02%</span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h4 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">誤検知率</h4>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light">業界最低水準の誤判定</p>
            </div>
          </div>

          {/* Result 3 */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20Japanese%20security%20operations%20center%20with%20large%20wall-mounted%20display%20screens%20showing%20data%20dashboards%2C%20dim%20blue%20ambient%20lighting%2C%20empty%20workstations%2C%20high-tech%20corporate%20environment%2C%20no%20people&width=480&height=600&seq=result-callcenter&orientation=portrait"
                alt="監視取引数"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/80 backdrop-blur-sm text-accent-400 text-sm md:text-base font-heading tracking-[0.05em]">10億+</span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h4 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">監視取引数（年間）</h4>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light">主要金融機関の取引をカバー</p>
            </div>
          </div>

          {/* Result 4 */}
          <div className="group cursor-pointer">
            <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20Japanese%20corporate%20meeting%20room%20with%20a%20large%20wooden%20conference%20table%2C%20leather%20chairs%2C%20glass%20walls%20with%20city%20view%2C%20warm%20ambient%20lighting%2C%20clean%20professional%20setting%2C%20empty%20room%2C%20no%20people&width=480&height=600&seq=result-handshake&orientation=portrait"
                alt="導入企業数"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute top-3 right-3">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-900/80 backdrop-blur-sm text-accent-400 text-sm md:text-base font-heading tracking-[0.05em]">50+</span>
              </div>
            </div>
            <div className="mt-4 space-y-1">
              <h4 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">導入企業数</h4>
              <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light">金融・EC業界を中心に拡大中</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}